import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import '../../styles/recipes/ServingsDialog.css';

const ServingsDialog = ({ recipe, onConfirm, onCancel }) => {
  const { t } = useLanguage();
  const [servings, setServings] = useState(recipe?.baseServings || 4);

  const handleConfirm = () => {
    if (servings && servings >= 1) {
      onConfirm(servings);
    }
  };

  return (
    <div className="servings-dialog-overlay" onClick={onCancel}>
      <div className="servings-dialog" onClick={(e) => e.stopPropagation()}>
        <h3 className="servings-dialog-question">
          {t('recipes.servingsQuestion') || 'Für wie viele Personen möchtest du kochen?'}
        </h3>
        <p className="servings-dialog-recipe-title">{recipe?.title}</p>

        <input
          type="number"
          min="1"
          max="50"
          value={servings}
          onChange={(e) => setServings(Number(e.target.value))}
          onKeyDown={(e) => e.key === 'Enter' && handleConfirm()}
          className="servings-dialog-input"
          autoFocus
        />

        <div className="servings-dialog-actions">
          <button className="btn btn-secondary" onClick={onCancel}>
            {t('recipes.cancel') || 'Abbrechen'}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={!servings || servings < 1}
          >
            {t('recipes.confirm') || 'Bestätigen'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServingsDialog;
